import React, { useState, useEffect } from 'react';
import './FeedbackMessage.css';

export function FeedbackMessage({ message, duration = 1500, onClear }) {
  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        onClear(); // Call the passed onClear function to clear the message
      }, duration);

      // Cleanup the timer when component unmounts or message changes
      return () => clearTimeout(timer);
    }
  }, [message, duration, onClear]);

  return message ? <div className="feedbackMessage">{message}</div> : null;
}
